import "./App.css";
import TopBar from "./Components/Top/TopBar";

import SongDetailsInput from "./Components/SongParts/SongDetailsInput";
import SongPartsInput from "./Components/SongParts/SongPartsInput";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import CssBaseline from "@material-ui/core/CssBaseline";
import produceMidi from "./Midi/produceMidi.jsx";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {

  },
  song: {
    marginTop: theme.spacing(5),
  }
}))

function App() {
  const classes = useStyles();

  return (
    <div className="App">
      <CssBaseline />
      <TopBar />

      <Container className={classes.song}>
        <Grid container spacing={0} justify="center">
          <Grid item xs={12} md={8} align="center">
            <SongPartsInput midi={produceMidi} />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default App;
